import {
  BulkActionContainerCol,
  Col,
  Table,
  TableActionBarRow,
  ValueOrFallback,
} from "melco-ui";
import { useTranslation } from "react-i18next";
import {
  BulkActionCount,
  FusionMelcoModelsUserImage,
  FormattedDate,
  ReportingMelcoMachineStatisticsModelsGroupListItem,
  Search,
  TableCellLink,
  useTableSelection,
} from "melco-shared-logic";
import { BulkActionDeleteMachineGroups } from "./BulkActionDeleteMachineGroups";
import { useMachineGroups } from "../../../hooks/reporting/useMachineGroups";

export type GroupListProps = {};

const DETAIL_VIEW_PATH = "/reporting/machine/groups";

export const MachineGroupsList: React.FC<GroupListProps> = ({ }) => {
  const { t } = useTranslation();
  const {
    data,
    isLoading,
    onTableConfigChange,
    pagination,
    searchQueryChange,
    refetch,
    errorComponent,
  } = useMachineGroups();

  const columns = [
    {
      title: t("reporting.machinegroups.list.columns.name"),
      key: "name",
      // dataIndex: "name",
      render: (item: any) => (
        <ValueOrFallback
          value={item.name}
          render={(value) => (
            <TableCellLink to={[DETAIL_VIEW_PATH, item.id].join("/")}>
              {value}
            </TableCellLink>
          )}
          fallback={t("global.fallback.empty")}
        />
      ),
      sorter: true,
    },
    {
      title: t("reporting.machinegroups.list.columns.machines"),
      key: "machine_count",
      dataIndex: "machine_count",
      sorter: true,
    },
    {
      title: t("reporting.machinegroups.list.columns.created"),
      key: "created_date",
      dataIndex: "created_date",
      sorter: true,
      render: (_: string, item: FusionMelcoModelsUserImage) => (
        <FormattedDate date={item.created_date} />
      ),
    },
    {
      title: t("reporting.machinegroups.list.columns.last_sync"),
      key: "updated_date",
      dataIndex: "updated_date",
      sorter: true,
      render: (_: string, item: FusionMelcoModelsUserImage) => (
        <FormattedDate date={item.updated_date} />
      ),
    },
  ];

  const { selectedRowKeys, setSelectedRowKeys, rowSelection, onRow } =
    useTableSelection<ReportingMelcoMachineStatisticsModelsGroupListItem>(
      () => { }
    );

  return (
    <>
      <TableActionBarRow>
        <Col>
          <Search
            onSearchInputChange={(query: string) => searchQueryChange(query)}
          />
        </Col>

        <BulkActionContainerCol>
          <BulkActionCount selectedCount={selectedRowKeys.length} />
          <BulkActionDeleteMachineGroups
            // allGroup={data}
            selectedRowKeys={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
            refetch={refetch}
          />
        </BulkActionContainerCol>
      </TableActionBarRow>

      <Table
        dataSource={data}
        columns={columns}
        rowKey="id"
        pagination={pagination}
        onChange={onTableConfigChange}
        onRow={onRow}
        rowSelection={rowSelection}
        noDataMessage={t("reporting.machinegroups.list.empty")}
        loading={isLoading}
        errorComponent={errorComponent}
      />
    </>
  );
};
